import React, {Component} from 'react';
import _ from 'lodash';

class FileDropzone extends Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();

        this.state = {highlight: false};
    }

    openFileDialog = () => {
        if (this.props.disabled) return;
        this.fileInputRef.current.click();
    };

    fileListToArray = list => {
        const array = [];
        for (var i = 0; i < list.length; i++) {
            const file = list.item(i);
            if(this.props.allowedFileTypes) {
                const matches = _.some(this.props.allowedFileTypes.map(fileType => _.endsWith(file.name, fileType)));
                if(matches) {
                    array.push(file);
                }
            } else {
                array.push(file);
            }
        }
        return array;
    };

    onFilesAdded = evt => {
        if (this.props.disabled) return;
        const files = evt.target.files;
        if (this.props.onFilesAdded) {
            const array = this.fileListToArray(files);
            this.props.onFilesAdded(array);
        }
    };

    onDragOver = evt => {
        evt.preventDefault();
        const files = this.fileListToArray(evt.dataTransfer.files);
        if (this.props.disabled || files.length === 0) return;
        this.setState({ highlight: true });
    };

    onDragLeave = () => {
        this.setState({ highlight: false });
    };

    onDrop = event => {
        event.preventDefault();
        if (this.props.disabled) return;

        const files = event.dataTransfer.files;
        if (this.props.onFilesAdded) {
            const array = this.fileListToArray(files);
            if(array.length > 0) {
                this.props.onFilesAdded(array);
            }
        }
        this.setState({ highlight: false });
    };

    render() {
        const accepts = this.props.allowedFileTypes ? _.join(this.props.allowedFileTypes, ', ') : '*/*';

        return <div
            className={`file-dropzone ${this.state.highlight ? 'highlight' : ''}`}
            onClick={this.openFileDialog}
            onDragOver={this.onDragOver}
            onDragLeave={this.onDragLeave}
            onDrop={this.onDrop}

            style={{cursor: this.props.disabled ? 'normal' : 'pointer'}}
        >
            <div className="file-dropzone-body">
                <i className="fa fa-cloud-upload" aria-hidden="true"/>

                <input
                    ref={this.fileInputRef}
                    className="file-input"
                    type="file"
                    accept={accepts}
                    multiple
                    onChange={this.onFilesAdded}
                />
            </div>
            <div className="file-dropzone-footer">
                {this.props.label ? this.props.label : 'Upload'}
            </div>
        </div>
    }
}


export default FileDropzone;
